module.exports = __webpack_public_path__ + "static/media/Olivia Main Wardrobe (4).3e6a0046.jpg";